/**
 * Interface for extending the `@phensley/cldr` library.
 *
 * @internal
 */
// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface Extension {
  // instantiate(cldr: CLDR): void;
}
